export default {
  "content": "<path d=\"M23 46c12.703 0 23-10.297 23-23S35.703 0 23 0 0 10.297 0 23s10.297 23 23 23zm-8.302-32.38c2.546-2.536 5.643-3.735 9.282-3.735C31.487 9.885 37 16.463 37 23.92c0 7.425-7.485 13.065-15.025 13.065V32.01c5.197 0 10.386-3.164 10.386-8.09 0-5.03-3.293-9.39-8.38-9.39-2.47 0-6.486 1.92-6.486 1.92l4.625 3.57H10.983l.017-.787V9l3.698 4.62z\"/>",
  "attrs": {
    "width": "46",
    "height": "46",
    "viewBox": "0 0 46 46",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};